import type { ComponentProps, ReactNode } from 'react';

import { cx } from '@mage-ui/styled-system/css';
import {
  checkboxBody,
  checkboxDescription,
  checkboxError,
  checkboxIcon,
  checkboxInner,
  checkboxInput,
  checkboxLabel,
  checkboxLabelWrapper,
} from '@mage-ui/styled-system/recipes';
import { Checkbox as CheckboxMantine } from '@mantine/core';

export type CheckboxProps = Omit<ComponentProps<'input'>, 'size'> & {
  error?: ReactNode;
  description?: ReactNode;
  value?: string;
  name?: string;
  checked?: boolean;
  label?: ReactNode;
  disabled?: boolean;
  indeterminate?: boolean;
  classNames?: {
    checkboxBody?: string;
    checkboxDescription?: string;
    checkboxError?: string;
    checkboxIcon?: string;
    checkboxInner?: string;
    checkboxInput?: string;
    checkboxLabel?: string;
    checkboxLabelWrapper?: string;
  };
};

export const Checkbox = ({
  classNames,
  ...props
}: CheckboxProps): ReactNode => {
  return (
    <CheckboxMantine
      classNames={{
        body: classNames?.checkboxBody ?? checkboxBody(),
        labelWrapper:
          classNames?.checkboxLabelWrapper ?? checkboxLabelWrapper(),
        label: classNames?.checkboxLabel ?? checkboxLabel(),
        description: classNames?.checkboxDescription ?? checkboxDescription(),
        error: classNames?.checkboxError ?? checkboxError(),
        input: cx(classNames?.checkboxInput ?? checkboxInput(), 'peer'),
        inner: classNames?.checkboxInner ?? checkboxInner(),
        icon: classNames?.checkboxIcon ?? checkboxIcon(),
      }}
      {...props}
    />
  );
};

Checkbox.displayName = 'Checkbox';
